import { useState } from "react";
import Features from "./Features";
import Plans from "./Plans";

const Responsive = () => {
  const [active, setActive] = useState(0);
  return (
    <div>
      <Plans active={active} setActive={setActive} />
      <Features active={active} />
    </div>
  );
};

export default Responsive;
